<template>
  <div id="CreateClaimSelectParts" class="bg-light pb-3">
    <div class="col">
      <p class="pl-3 py-4">Select the parts you would like to claim below.</p>
      <div class="col">
        <div class="row no-gutters">
          <DnTable
            id="claimItemSelection"
            hover
            striped
            :items="InvoiceItems"
            :fields="claimsPartsDataColumns"
            stacked="md"
            :no-provider-filtering="true"
            show-empty
            empty-text="Loading Invoice Items..."
            :no-local-sorting="true"
            class="blue mb-3"
            :tbody-tr-class="RowClass"
          >
            <template #selected="{ row }">
              <b-form-group>
                <input
                  v-if="ShowPartCheckbox(row)"
                  :id="'checkbox' + row.index"
                  v-model="row.item.selected"
                  type="checkbox"
                  @change="ValidateAndSend"
                />
                <div v-if="IsNotNullOrUndefined(row, 'item.OrderedQuantity') && row.item.OrderedQuantity == 0">
                  <div><small>This row is disabled because the quantity is zero.</small></div>
                  <div><small>Please select another row.</small></div>
                </div>
                <div
                  v-if="IsNotNullOrUndefined(row, 'item.ReturnOemPartCode') && row.item.ReturnOemPartCode.includes('EXXN')"
                >
                  <div><small>Exxon oil claims should be filed directly with your Exxon distributor.</small></div>
                </div>
              </b-form-group>
            </template>
            <template #PartDescription="{ row }">
              <div>{{ row.item.PartDescription }}</div>
              <div v-if="row.item.PartId === null" class="alert alert-danger">
                Unable to submit a claim on this item.<br />
                Contact Dealer Support {{ tenantDetails.SupportPhoneNumber }}.
              </div>
            </template>
          </DnTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ClaimsService } from "@/services/ClaimsService";
import DnTable from "@/components/Elements/DnTable/DnTable.vue";

export default {
  components: {
    DnTable,
  },
  props: {
    invoiceData: {
      type: Object,
      default: () => ({}),
    },
    validationState: {
      selectPartsTab: false,
    },
    invoiceState: {
      type: Object,
      default: () => ({}),
    },
    claimDto: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    claimsPartsDataColumns: [
      { key: "selected", label: "", sortable: false },
      { key: "InvoiceLineNumber", label: "Line Number", sortable: false },
      { key: "OrderedOemPartCode", label: "Part Number", sortable: false },
      { key: "PartDescription", label: "Description", sortable: false },
      { key: "OrderedQuantity", label: "Quantity Shipped", sortable: false },
    ],
    InvoiceItems: [],
  }),

  computed: {
    ...mapGetters(["user", "activeAccountId", "tenantDetails"]),
  },

  methods: {
    Setup() {
      this.validationState.selectPartsTab = false;
      this.claimDto.Items = []; // empty the selected items array in the case the user uses back from next step
      if (this.invoiceState.InvoiceNumber === undefined) {
        this.LoadInvoiceItems().then((claimItemsDto) => {
          this.InvoiceItems = claimItemsDto.data;
          this.AddSelectedProperty();
        });
      } else {
        this.InvoiceItems = this.invoiceState.LineItems;
      }
    },
    ValidateAndSend: function () {
      var rowSelected = this.HasRowSelected();
      if (rowSelected === undefined) {
        this.validationState.selectPartsTab = false;
      } else {
        // if error message shown previously, clear it when row is selected.
        this.$emit("error", "");
        this.SetupAndEmitData();
        this.validationState.selectPartsTab = true;
      }
    },
    SetupAndEmitData: function () {
      this.claimDto.Items = [];

      for (let i = 0; i < this.InvoiceItems.length; i++) {
        if (this.InvoiceItems[i].selected) {
          this.claimDto.Items.push(this.InvoiceItems[i]);
        }
      }
    },
    LoadInvoiceItems() {
      return ClaimsService.LoadClaimInvoiceItems(
        this.activeAccountId,
        this.user.UserId,
        this.invoiceData.invoiceId,
        this.invoiceData.invoiceSource
      );
    },
    AddSelectedProperty() {
      // Adding a property of `selected` to each line item to track which item is selected to emit back to parent.
      for (let i = 0; i < this.InvoiceItems.length; i++) {
        this.InvoiceItems[i].selected = false;
      }
    },
    HasRowSelected: function () {
      return this.InvoiceItems.find(function (element) {
        return element.selected;
      });
    },
    RowClass(item, type) {
      if (item && item.OrderedQuantity == 0) {
        return "disabled";
      }
      return "";
    },
    ShowPartCheckbox(row) {
      let shouldShowCheckbox =
        row.item.PartId !== null && row.item.OrderedQuantity != 0 && !row.item.ReturnOemPartCode.includes("EXXN");
      return shouldShowCheckbox;
    },
  },
};
</script>
